import { Badge } from "../../../../../components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "../../../../../components/ui/tooltip";
import { useOpcoesBloqueio } from "../hooks/use-bloqueios";
import { CadastroDocument } from "../types";
import { formatDataHora, rotuloMotivo } from "../utils/bloqueio-utils";

// Status de um cadastro na aba Cadastros: elegível, bloqueado (documento na ops)
// ou telefone desativado (roteamento). Detalhes no tooltip.
export function BloqueioStatus({ doc }: { doc: CadastroDocument }) {
  const { data: opcoes } = useOpcoesBloqueio();

  if (!doc.bloqueio_id) {
    return (
      <span className="inline-flex items-center text-xs font-semibold text-green-600">
        🟢 Recebe oferta
      </span>
    );
  }

  const porTelefone = !!doc.bloqueio_telefone;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge
          variant="outline"
          className={
            porTelefone
              ? "cursor-help border-amber-300 bg-amber-50 text-amber-800"
              : "cursor-help border-red-300 bg-red-50 text-red-700"
          }
        >
          {porTelefone ? "Telefone desativado" : "Bloqueado"} ·{" "}
          {doc.bloqueio_origem === "gestor" ? "Gestor" : "Cliente"}
        </Badge>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">
        <p>
          {rotuloMotivo(
            doc.bloqueio_motivo_codigo,
            doc.bloqueio_motivo_texto,
            opcoes?.motivos,
          )}
        </p>
        <p className="opacity-80">
          {doc.bloqueio_criado_por} · {formatDataHora(doc.bloqueio_criado_em)}
        </p>
      </TooltipContent>
    </Tooltip>
  );
}
